module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMTAiIGhlaWdodD0iMTEwIiB2aWV3Qm94PSIwIDAgMTEwIDExMCI+CiAgPHRpdGxlPmJ0bl95ZXM8L3RpdGxlPgogIDxnPgogICAgPHJlY3Qgd2lkdGg9IjExMCIgaGVpZ2h0PSIxMTAiIHJ4PSIxNSIgcnk9IjE1IiBmaWxsPSIjZTQwNTgzIi8+CiAgICA8cGF0aCBkPSJNNTUsOTNBMzgsMzgsMCwxLDEsOTMsNTUsMzgsMzgsMCwwLDEsNTUsOTNabTAtNjVBMjcsMjcsMCwxLDAsODIsNTUsMjcsMjcsMCwwLDAsNTUsMjhaIiBmaWxsPSIjZmZmIi8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btn_yes.svg
// module id = 3
// module chunks = 0